import SectionLogo from "../SectionLogo";

export const MeetOwnerSection = () => {
  return (
    <section id="meet-owner" className="py-24 bg-[#0a0318] relative">
      <SectionLogo position="center" size="large" opacity={0.04} />
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <div className="bg-[#110422]/50 border border-amber-500/20 rounded-3xl p-8 md:p-12">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              <div className="lg:col-span-1 flex flex-col items-center">
                <div className="bg-gradient-to-br from-amber-600 to-amber-500 p-1 mb-6 rounded-xl inline-block">
                  <div className="overflow-hidden rounded-lg" style={{ backgroundColor: "#e5e5e5" }}>
                    <img
                      src="/images/mitch-headshot.jpg"
                      alt="Demetrius Mitch Belton"
                      className="max-w-[220px] h-auto"
                    />
                  </div>
                </div>
                <h3 className="text-2xl font-bold text-white text-center">Demetrius &ldquo;Mitch&rdquo; Belton</h3>
                <p className="text-amber-300 text-center">Founder & Owner</p>
                <p className="text-amber-400 text-sm text-center">Ice Man Cryo Therapy & Wellness</p>
              </div>
              <div className="lg:col-span-2">
                <p className="text-gray-300 text-lg mb-4">
                  Mitch Belton founded Ice Man Cryo to bring mobile, targeted recovery services directly to athletes
                  and active communities.
                </p>
                <p className="text-gray-300 text-lg mb-4">
                  Mitch was a 3-year letterman and record holder in football and served as a Graduate Assistant Coach
                  at <span className="text-amber-400 font-semibold">Clemson University</span> where he earned a
                  Bachelor of Science in Management and Economics and a Masters Degree in Business Administration. He
                  has officiated basketball, football and baseball at the high school and college level for over 25
                  years and built strong relationships with gyms and athletic organizations in the Atlanta area.
                </p>
                <p className="text-gray-300 text-lg">
                  He is certified on the{" "}
                  <span className="text-amber-400 font-semibold">America Cryo Subzero system</span> and focused on
                  delivering fast, effective recovery solutions without the need for a full-body cryotherapy chamber.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
